import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
export function filterItems(items, query, getText) {
    const q = query.trim().toLowerCase();
    if (!q)
        return items;
    return items.filter((item) => getText(item).toLowerCase().includes(q));
}
function initialsFrom(text) {
    const base = text.trim();
    if (!base)
        return "?";
    const parts = base.split(/\s+/).filter(Boolean);
    if (parts.length >= 2)
        return (parts[0][0] + parts[1][0]).toUpperCase();
    return base.slice(0, 2).toUpperCase();
}
function Avatar({ photoUrl, label }) {
    const [broken, setBroken] = useState(false);
    if (photoUrl && !broken) {
        return (_jsx("img", { src: photoUrl, alt: "", className: "h-7 w-7 shrink-0 rounded-full object-cover", onError: () => setBroken(true), referrerPolicy: "no-referrer" }));
    }
    return (_jsx("span", { className: "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-slate-200 text-[10px] font-medium text-slate-600", children: initialsFrom(label) }));
}
export function SearchablePicker({ items, value, onChange, getKey, getLabel, getSublabel, getPhotoUrl, placeholder = "Select…", }) {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    const rootRef = useRef(null);
    const selected = useMemo(() => items.find((item) => getKey(item) === value) ?? null, [items, value, getKey]);
    const filtered = useMemo(() => filterItems(items, query, (item) => `${getLabel(item)} ${getSublabel(item)}`), [items, query, getLabel, getSublabel]);
    useEffect(() => {
        if (!open)
            return;
        function onDocClick(ev) {
            if (rootRef.current && !rootRef.current.contains(ev.target)) {
                setOpen(false);
                setQuery("");
            }
        }
        function onKey(ev) {
            if (ev.key === "Escape") {
                setOpen(false);
                setQuery("");
            }
        }
        document.addEventListener("mousedown", onDocClick);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("mousedown", onDocClick);
            document.removeEventListener("keydown", onKey);
        };
    }, [open]);
    function choose(item) {
        onChange(getKey(item));
        setOpen(false);
        setQuery("");
    }
    return (_jsxs("div", { ref: rootRef, className: "relative", children: [_jsxs("button", { type: "button", onClick: () => setOpen((o) => !o), className: "flex w-full items-center gap-2 rounded border border-slate-300 px-2 py-1 text-left text-xs", children: [selected ? (_jsxs(_Fragment, { children: [_jsx(Avatar, { photoUrl: getPhotoUrl(selected), label: getLabel(selected) }), _jsxs("span", { className: "min-w-0 flex-1 truncate", children: [_jsx("span", { className: "font-medium text-slate-900", children: getLabel(selected) }), getSublabel(selected) && (_jsx("span", { className: "ml-1 text-slate-500", children: getSublabel(selected) }))] })] })) : (_jsx("span", { className: "text-slate-400", children: placeholder })), _jsx("span", { className: "ml-auto text-slate-400", children: "\u25BE" })] }), open && (_jsxs("div", { className: "absolute z-20 mt-1 w-full rounded border border-slate-200 bg-white shadow-lg", children: [_jsx("input", { autoFocus: true, value: query, onChange: (ev) => setQuery(ev.target.value), placeholder: "Search\u2026", className: "w-full border-b border-slate-200 px-2 py-1.5 text-xs focus:outline-none" }), _jsxs("ul", { className: "max-h-64 overflow-auto py-1", children: [filtered.map((item) => (_jsx("li", { children: _jsxs("button", { type: "button", onClick: () => choose(item), className: "flex w-full items-center gap-2 px-2 py-1.5 text-left hover:bg-slate-50", children: [_jsx(Avatar, { photoUrl: getPhotoUrl(item), label: getLabel(item) }), _jsxs("span", { className: "min-w-0 flex-1", children: [_jsx("span", { className: "block truncate text-xs font-medium text-slate-900", children: getLabel(item) }), _jsx("span", { className: "block truncate text-[11px] text-slate-500", children: getSublabel(item) })] })] }) }, getKey(item)))), filtered.length === 0 && (_jsx("li", { className: "px-2 py-3 text-center text-xs text-slate-400", children: "No matches" }))] })] }))] }));
}
